"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CiPortalApiConfig = void 0;
class CiPortalApiConfig {
    constructor(baseApiUrl, apiVersion, authRefreshWindow) {
        this.baseApiUrl = baseApiUrl;
        this.apiVersion = apiVersion;
        this.authRefreshWindow = authRefreshWindow;
        //
    }
    urlWithVersion(url, versionOverride) {
        var _a;
        let ver = (_a = versionOverride !== null && versionOverride !== void 0 ? versionOverride : this.apiVersion) !== null && _a !== void 0 ? _a : '';
        if (ver)
            ver = `/${ver}`;
        const prepend = `${this.baseApiUrl}${ver}`;
        // Sometimes the url may already be fully qualified
        if (!url.startsWith(prepend)) {
            return `${prepend}${url}`;
        }
        return url;
    }
    urlWithoutVersion(url) {
        // Sometimes the url may already be fully qualified
        if (!url.startsWith(this.baseApiUrl)) {
            return `${this.baseApiUrl}${url}`;
        }
        return url;
    }
}
exports.CiPortalApiConfig = CiPortalApiConfig;
